import React, {Component} from "react";
import { Context } from "context";

import clone from 'clone';
import segment from "segment";

import styles from "./Viewer.module.scss";

import ToolBar from 'editor/workspace/window/viewer/toolbar/ToolBar';
import Visual from 'editor/workspace/window/viewer/visual/Visual';
import Sheet from 'editor/workspace/window/viewer/sheet/Sheet';
import Matrix from "util/table/Matrix";

export default class Viewer extends Component {
    state = {
        formula: "",
        pointDragActive: false,
        modifiedTablePreview: undefined
    };

    static contextType = Context;

    // todo - Something weird going on with this.props.table.dataAxis and nextProps.table.dataAxis always being the same so I've disabled this for now [Tom]
    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     const dataAxisChanged = !equals(this.props.table.dataAxis.matrix.values, nextProps.table.dataAxis.matrix.values);
    //     console.log(this.props.table.dataAxis.matrix.values[0][0]);
    //     console.log(nextProps.table.dataAxis.matrix.values[0][0]);
    //     console.log(dataAxisChanged);
    //     const uploadedChanged = !equals(this.props.uploaded.dataAxis.matrix.values, nextProps.uploaded.dataAxis.matrix.values);
    //     const modifiedChanged = !equals(this.props.modified.dataAxis.matrix.values, nextProps.modified.dataAxis.matrix.values);
    //
    //     const diffTypeChanged = this.props.diffType !== nextProps.diffType;
    //     const valueTypeChanged = this.props.valueType !== nextProps.valueType;
    //     const viewModeChanged = this.props.viewMode !== nextProps.viewMode;
    //
    //     const selectionChanged = !equals(this.props.selection, nextProps.selection);
    //
    //     const formulaChanged = this.state.formula !== nextState.formula;
    //
    //     const numberPadChanged = this.props.numberPad !== nextProps.numberPad;
    //
    //     const selectionFinalisedChanged = this.props.selectionFinalised !== nextProps.selectionFinalised;
    //
    //     return dataAxisChanged || uploadedChanged || modifiedChanged || diffTypeChanged || valueTypeChanged || viewModeChanged || selectionChanged || formulaChanged || numberPadChanged || selectionFinalisedChanged;
    // }

    /**
     * Apply a function change to the map data
     * @param {function} formula
     */
    apply = async (formula) => {
        if(this.props.valueType === "modified"){
            let modifiedTable = this.props.modified;
            let selectedMatrix;

            try {
                selectedMatrix = modifiedTable.dataAxis.matrix.extract(this.props.selection.topLeft, this.props.selection.bottomRight);
            } catch (error) {
                this.props.handleError(error);
                this.context.alert("You haven't made a selection", "Danger");
                return
            }

            try {
                selectedMatrix = selectedMatrix.transform(formula);
            } catch (error) {
                this.props.handleError(error);
                this.context.alert("You've entered invalid characters into the formula bar", "Danger");
                return
            }

            try {
                modifiedTable.dataAxis.matrix = modifiedTable.dataAxis.matrix.insert(selectedMatrix, this.props.selection.topLeft);
            } catch (error) {
                this.props.handleError(error);
                this.context.alert("Something went wrong", "Danger");
                return
            }

            this.props.save(modifiedTable);
        }
    };

    updateValue = async ({x, y}) => {
        if(this.props.valueType === "modified"){
            let modifiedTable = this.props.modified;

            try {
                modifiedTable.dataAxis.matrix = modifiedTable.dataAxis.matrix.insert({values: [[y]]}, {i: 0, j: x});
            } catch (error) {
                this.props.handleError(error);
                this.context.alert(error.message, "Danger");
            }
        }
    };

    /**
     * Smooth the selected sub-matrix
     */
    smooth = async () => {
        await segment.track("project_edited", {
            application: "editor",
            type: "smooth",
            projectId: this.context.id,
            mapId: this.props.window.mapId,
            axisId: this.props.table.id,
            projectType: this.context.metadata.projectType === "DEMO" ? "demo" : "user",
        })
        if(this.props.valueType === "modified"){
            const modifiedTable = this.props.modified;

            try {
                const selectedMatrix = modifiedTable.dataAxis.matrix.extract(this.props.selection.topLeft, this.props.selection.bottomRight);
                const smoothedMatrix = selectedMatrix.smooth();
                modifiedTable.dataAxis.matrix = modifiedTable.dataAxis.matrix.insert(smoothedMatrix, this.props.selection.topLeft);
            } catch (error) {
                alert(error.message); //todo: invalid start, end point should say invalid selection
            }

            this.props.save(modifiedTable);
        }
    };

    /**
     * Calculate a corner gradient for the selected sub-matrix
     * @param {Object} table
     * @param {String} point - tr, tl, bl or br //todo - do we already have something called "point"?
     * @param {Number} value
     */
    applyCornerGradient = async (table, point, value) => {
        let modifiedTable = clone(table);

        let selectedMatrix = modifiedTable.dataAxis.matrix.extract(this.props.selection.topLeft, this.props.selection.bottomRight);

        let xs = modifiedTable.xAxis.matrix.extract({i: 0, j: this.props.selection.topLeft.j}, {i: 0, j: this.props.selection.bottomRight.j});
        let ys = modifiedTable.yAxis.matrix.extract({i: 0, j: this.props.selection.topLeft.i}, {i: 0, j: this.props.selection.bottomRight.i});

        // reverse axis values so that when gradient is flipped, the axis is the right way around
        if(point === "tr" || point === "tl") ys = ys.reverseJ();
        if(point === "bl" || point === "tl") xs = xs.reverseJ();

        let gradient = Matrix.cornerGradient(selectedMatrix.shape, 1, 1 + value, selectedMatrix.precision, xs.values.reduce((acc, val) => acc.concat(val), []), ys.values.reduce((acc, val) => acc.concat(val), []));

        if(point === "tr" || point === "tl") gradient = gradient.reverseI();
        if(point === "bl" || point === "tl") gradient = gradient.reverseJ();

        selectedMatrix = selectedMatrix.elementwiseMultiply(gradient);

        modifiedTable.dataAxis.matrix = modifiedTable.dataAxis.matrix.insert(selectedMatrix, this.props.selection.topLeft);

        this.setState({formula: `${(value * 100).toFixed(2)}%`, pointDragActive: true,modifiedTablePreview: modifiedTable});

        // We don't run this.save in these functions because it's handled by <Sheet /> on mouseup
    };

    /**
     * Calculate a edge gradient for the selected sub-matrix
     * @param {Object} table
     * @param {String} point - top, left, bottom or right //todo - do we already have something called "point"?
     * @param {Number} value
     */
    applyEdgeGradient = async (table, point, value) => {
        let modifiedTable = clone(table);

        let selectedMatrix = modifiedTable.dataAxis.matrix.extract(this.props.selection.topLeft, this.props.selection.bottomRight);

        if (selectedMatrix.shape.m > 1 || selectedMatrix.shape.n > 1){
            let gradient;
            if(point === "left" || point === "right") {
                //horizontal
                let xs = [...Array(selectedMatrix.shape.n).keys()];

                if (modifiedTable.xAxis){
                    let selectedXAxisMatrix = modifiedTable.xAxis.matrix.extract({i: 0, j: this.props.selection.topLeft.j}, {i: 0, j: this.props.selection.bottomRight.j});
                    xs = selectedXAxisMatrix.values.reduce((acc, val) => acc.concat(val), [])
                }

                if(point === "left") xs.reverse(); // reverse axis values so that when gradient is flipped, the axis is the right way around

                gradient = Matrix.edgeGradient(selectedMatrix.shape, 1, 1 + value, selectedMatrix.precision, xs, undefined);
            } else {
                //vertical
                let ys = [...Array(selectedMatrix.shape.n).keys()];

                if (modifiedTable.yAxis){
                    let selectedYAxisMatrix = modifiedTable.yAxis.matrix.extract({i: 0, j: this.props.selection.topLeft.i}, {i: 0, j: this.props.selection.bottomRight.i});
                    ys = selectedYAxisMatrix.values.reduce((acc, val) => acc.concat(val), [])
                }

                if(point === "top") ys.reverse(); // reverse axis values so that when gradient is flipped, the axis is the right way around

                gradient = Matrix.edgeGradient(selectedMatrix.shape, 1, 1 + value, selectedMatrix.precision, undefined, ys);
            }

            // flip gradient
            if(point === "top") gradient = gradient.reverseI();
            if(point === "left") gradient = gradient.reverseJ();

            selectedMatrix = selectedMatrix.elementwiseMultiply(gradient);
        } else {
            selectedMatrix = selectedMatrix.transform(x => x*(1 + value)); //single cell transform
        }

        modifiedTable.dataAxis.matrix = modifiedTable.dataAxis.matrix.insert(selectedMatrix, this.props.selection.topLeft);

        this.setState({formula: `${(value * 100).toFixed(2)}%`, pointDragActive: true, modifiedTablePreview: modifiedTable});

        // We don't run this.save in these functions because it's handled by <Sheet /> on mouseup
    };

    updateFormula = (formula) => {
        return new Promise(resolve => this.setState({formula}, resolve))
    };

    save = async table => {
        await this.props.save(table);
        this.setState({pointDragActive: false})
    }

    render() {
        return (
            <div className={styles.viewer}>
                {(this.props.viewMode === "both" || this.props.viewMode === "visual") && this.props.table.dimension > 0 &&
                    <Visual
                        table={this.state.pointDragActive? this.state.modifiedTablePreview : this.props.table}
                        selection={this.props.selection}
                        revision={this.props.revision}
                        uploaded={this.props.uploaded}
                        updateValue={this.updateValue}
                        save={this.props.save.bind(this, this.props.modified)}
                    />
                }
                {(this.props.viewMode === "both" || this.props.viewMode === "sheet") &&
                    <>
                        <ToolBar
                            table={this.props.table}
                            window={this.props.window}
                            selection={this.props.selection}
                            selectionFinalised={this.props.selectionFinalised}
                            apply={this.apply}
                            smooth={this.smooth}
                            updateFormula={this.updateFormula}
                            formula={this.state.formula}
                            activateNumberPad={this.props.activateNumberPad}
                            closeNumberPad={this.props.closeNumberPad}
                            numberPad={this.props.numberPad}
                            focused={this.props.focused}
                        />
                        <Sheet
                            window={this.props.window}
                            table={this.state.pointDragActive? this.state.modifiedTablePreview : this.props.table}
                            uploaded={this.props.uploaded}
                            selection={this.props.selection}
                            selectAll={this.props.selectAll }
                            setSelection={this.props.setSelection}
                            endSelection={this.props.endSelection}
                            updateFormula={this.updateFormula}
                            diffType={this.props.diffType}
                            applyCornerGradient={this.applyCornerGradient}
                            applyEdgeGradient={this.applyEdgeGradient}
                            activateAxisEditing={this.props.activateAxisEditing}
                            save={this.save}
                        />
                    </>
                }
            </div>
        )
    }
}